export default __webpack_public_path__ + "static/media/arrow-right-solid.6a002e1d.svg";